module.exports = __webpack_public_path__ + "media/assets/images/column-thumbnail_car-982da69b5815101f50e3c48deb38b92f.png";